import { useMutation } from "urql";
import { graphql } from "../gql";

const deleteDerivedImageMutation = graphql(`
  mutation DeleteDerivedImageMutation(
    $bucket: String!
    $id: ID!
    $key: String!
  ) {
    removeDerivedImage(bucket: $bucket, id: $id, key: $key) {
      ...SongFields
    }
  }
`);

export function useDeleteDerivedImage() {
  const [mutationResult, executeMutation] = useMutation(
    deleteDerivedImageMutation,
  );

  const deleteDerivedImage = async (
    bucket: string,
    id: string,
    key: string,
  ): Promise<boolean> => {
    const result = await executeMutation({
      bucket,
      id,
      key,
    });

    if (result.error) {
      console.error(
        "Fehler beim Löschen des abgeleiteten Bildes:",
        result.error,
      );
      return false;
    }

    return result.data?.removeDerivedImage !== undefined;
  };

  return {
    deleteDerivedImage,
    fetching: mutationResult.fetching,
    error: mutationResult.error,
  };
}
